import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {TombOfAkhenatenSoundConfig} from "../TombOfAkhenatenSoundConfig";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {TOASlideShowPage} from "../intro/TOASlideShowPage";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

export class SoundManager {
    // #316
    //private static mediumLargeWinTimeOut: any;
    private _isBonus: boolean = false;

    constructor() {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.onReady());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_GAME_START, () => this.onGameStart());
    }

    private static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    //common methods
    public static playSound(name: string, repeat?: number, volume?: number): void {
        this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume
        });
    }

    public static fadeInSound(name: string, duration: number, to?: number): void {
        this.soundPlayer.fadeTrack({
            name: name,
            duration: duration,
            to: to ? to : 1
        });
    }

    public static fadeOutSound(name: string, duration: number, to?: number): void {
        this.soundPlayer.fadeTrack({
            name: name,
            duration: duration,
            to: to ? to : 0
        });
    }

    public static stopSound(name: string, fadeOutDuration?: number): void {
        this.soundPlayer.stopTrack(name);
    }

    public static playKeypadSound(name: string): void {
        this.soundPlayer.playKeypadSound(name);
    }

    // #268 scatter landing sound start
    public static playScatterLandingSound(scatterCounter: number, isBonusGame: boolean) {
        //Logger.logDev("sounds - playScatterLandingSound ", " scatterCounter - ", scatterCounter, " isBonusGame  - ", isBonusGame);
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            if (isBonusGame) {
                SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.SCATTER_ADDITIONAL_SPIN);
            } else {
                if (scatterCounter > 2) {
                    scatterCounter = 3
                }
                SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.SCATTER_LANDING + scatterCounter);
            }
        }
    }

    // #268 scatter anticipation sound start
    public static playScatterAnticipationSound() {
        //Logger.logDev("sounds - playScatterAnticipationSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.SCATTER_ANTICIPATION_LOOP, Infinity, 1);
        }
    }

    // #268 scatter anticipation sound stop
    public static stopScatterAnticipationSound() {
        //Logger.logDev("sounds - stopScatterAnticipationSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.SCATTER_ANTICIPATION_LOOP);
        }
    }

    // #268 scatter anticipation fail sound start
    public static playScatterAnticipationFailSound() {
        //Logger.logDev("sounds - playScatterAnticipationFailSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.SCATTER_ANTICIPATION_FAIL);
        }
    }

    // #271 normal wild landing sound start
    public static playNormalWildLandingSound() {
        //Logger.logDev("sounds - playNormalWildLandingSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.NORMAL_WILD_LANDING);
        }
    }

    // #271 extra wild landing sound start
    public static playExtraWildLandingSound() {
        //Logger.logDev("sounds - playExtraWildLandingSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.EXTRA_WILD_LANDING);
        }
    }

    // #264 bet way sweep sound start
    public static playBetWaySweepSound(winType: string | undefined) {
        //Logger.logDev("sounds - playBetWaySweepSound", winType);
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            if (winType) {
                winType = winType.charAt(0).toUpperCase() + winType.slice(1);
                SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.BETWAY_SWEEP + winType);
            }
        }
    }

    // #264 win sounds start
    public static playWinSound(winType: string) {
        //Logger.logDev("sounds - playWinSound", winType);
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            winType = winType.charAt(0).toUpperCase() + winType.slice(1);
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.WIN_SOUND + winType);
        }
    }

    // #264 medium & large win count up sound start
    public static playMediumLargeWinCountUpSound() {
        //Logger.logDev("sounds - playMediumLargeWinCountUpSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.COUNT_UP_SOUND, Infinity, 1);
        }
    }

    // #264 medium & large win count up sound stop
    public static stopMediumLargeWinCountUpSound() {
        //Logger.logDev("sounds - stopMediumLargeWinCountUpSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.COUNT_UP_SOUND);
        }
    }

    // #264 medium & large final count sound start
    public static playMediumLargeFinalCountSound() {
        //Logger.logDev("sounds - playMediumLargeFinalCountSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.FINAL_COUNT_SOUND);
        }
    }

    // #286 big multiplier spam sound start
    public static playBigMultiplierSound(multiplier : number) {
        //Logger.logDev("sounds - playBigMultiplierSound" + multiplier);
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.BIG_MULTIPLIER_SPAM);
        }
    }

    // #286 multiplier up sound start
    public static playMultiplierUpSound(multiplier: number) {
        //Logger.logDev("sounds - playMultiplierUpSound", multiplier);
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.MULTIPLIER_UP);
        }
    }

    // #270 FS Intro sound start
    public static playFSIntroSound() {
        //Logger.logDev("sounds - playFSIntroSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.FS_INTRO);
        }
    }

    // #270 FS intro Outro Continue Button sound start
    public static playFSContinueBtnSound() {
        //Logger.logDev("sounds - playFSContinueBtnSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.FS_CONTINUE_BTN);
        }
    }

    // #286 bonus game start sound start
    public static playBonusGameStartSound() {
        //Logger.logDev("sounds - playBonusGameStartSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.FS_GAME_START);
        }
    }

    // #286 bonus game outro fade in sound start
    public static playBonusGameOutroSound() {
        //Logger.logDev("sounds - playBonusGameOutroSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.FS_FADE_OUTRO);
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.FS_BG_MUSIC_LOOP, 3000, 0.4);
        }
    }

    // #286 bonus game ends sound start
    public static playBonusGameEndSound() {
        //Logger.logDev("sounds - playBonusGameEndSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.FS_GAME_ENDS);
        }
    }

    // #265 stone press sound start
    public static playStonePressSound(rows: number) {
        //Logger.logDev("sounds - playStonePressSound for rows: ", rows);
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            let fastText: string = GameSetting.isFastSpin ? "Fast" : "";
            if(rows === 3){
                SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.STONE_PRESS + fastText);
                SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.STONE_PRESS + fastText);
            }else{
                SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.STONE_PRESS + "2" + fastText);
                SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.STONE_PRESS + "2" + fastText);
            }
        }
    }

    // #219, #335 reel spinning sound start
    public static playReelSpinningSound() {
        //Logger.logDev("sounds - playReelSpinningSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.REELS_SPIN);
        }
    }

    // #219 reel spinning sound stop
    public static stopReelSpinningSound() {
        //Logger.logDev("sounds - stopReelSpinningSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.REELS_SPIN);
        }
    }

    // #225 reel landing sound start
    public static playReelLandingSound() {
        //Logger.logDev("sounds - playReelLandingSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.REELS_LANDING);
        }
    }

    // #225 reel landing sound start
    public static playRopeRotateSound() {
        //Logger.logDev("sounds - playRopeRotateSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.ROPE_ROTATE);
        }
    }

    // #240 bonus bg sound on FS intro start
    public static playBonusBgSound() {
        //Logger.logDev("sounds - playBonusBgSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.FS_BG_MUSIC_LOOP, Infinity, 1);
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_1, 10);
            SoundManager.stopMainGameRespinBgSounds(1500);
            //#316
            //SoundManager.fadeMediumAndLargeWinSound(10);
        }
    }

    // #240 bonus bg sound on FS outro stop
    public static stopBonusBgSound() {
        //Logger.logDev("sounds - stopBonusBgSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.FS_BG_MUSIC_LOOP);
            SoundManager.fadeInSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_1, 2000);
        }
    }

    //#316 main game first respin bg music sound start
    public static playMainGameRespinFirstBgSound(): void {
        //Logger.logDev("sounds - playMainGameRespinFirstBgSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.fadeInSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_2, 500);
        }
    }

    //#316 main game second respin bg music sound start
    public static playMainGameRespinSecondBgSound(): void {
        //Logger.logDev("sounds - playMainGameRespinSecondBgSound at vol: 0.8");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.fadeInSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_3, 500, 0.8);
        }
    }

    //#316 main game second respin bg music sound start
    public static playMainGameRespinFinalBgSound(): void {
        //Logger.logDev("sounds - playMainGameRespinFinalBgSound at vol: 1");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.fadeInSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_3, 500, 1);
        }
    }

    //#316 first & second respin bg music sound stop
    public static stopMainGameRespinBgSounds(duration: number): void {
        //Logger.logDev("sounds - stopMainGameRespinBgSounds", duration);
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_2, duration);
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_3, duration);
        }
    }

    /* #316
    // #252 Medium & Large Win sound start
    public static playMediumAndLargeWinSound(): void {
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.fadeInSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_2, 200);
            if (SoundManager.mediumLargeWinTimeOut) {
                clearTimeout(SoundManager.mediumLargeWinTimeOut);
            }
            SoundManager.mediumLargeWinTimeOut = setTimeout(this.fadeMediumAndLargeWinSound.bind(this), 20000);
        }
    }

    // #252 Medium & Large Win sound stop
    public static fadeMediumAndLargeWinSound(duration?: number): void {
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_2, duration ? duration : 15000);
        }
    }*/

    //#304 bigwin betway sweep sound start
    public static playBigWinBetWaySweepSound() {
        //Logger.logDev("sounds - playBigWinBetWaySweepSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            //#328 David feedback
            //SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.BW_INITIAL_WIN);
            SoundManager.playBetWaySweepSound("large");
            //#304
            //SoundManager.fadeOutAllBGMusic(1500);
        }
    }

    //#361, #304
    public static fadeOutAllBGMusic(duration: number) {
        //Logger.logDev("sounds - fadeOutAllBGMusic ", duration);
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_1, duration);
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_2, duration);
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_3, duration);
            SoundManager.fadeOutSound(TombOfAkhenatenSoundConfig.instance.FS_BG_MUSIC_LOOP, duration);
        }
    }

    //#328 bigwin initial win sound start
    public static playBigWinInitialWinSound() {
        //Logger.logDev("sounds - playBigWinInitialWinSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.BW_INITIAL_WIN);
            SoundManager.fadeOutAllBGMusic(1500);
        }
    }

    //#304 bigwin levels sound start
    public static playBigWinLevelSound(winLevel: number) {
        if (winLevel !== 0) {
            //Logger.logDev("sounds - playBigWinLevelSound stopping sound: ", winLevel);
        }
        //Logger.logDev("sounds - playBigWinLevelSound", (winLevel + 1));
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            if (winLevel !== 0) {
                SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.BW_LEVEL + winLevel);
            }
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.BW_LEVEL + (winLevel + 1));
        }
    }

    //#304 bigwin levels sound stop
    public static stopBigWinLevelSound(winLevel: number) {
        //Logger.logDev("sounds - stopBigWinLevelSound", (winLevel + 1));
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.BW_LEVEL + (winLevel + 1));
        }
    }

    //#304 bigwin ends sound start
    public static playBigWinEndSound(isBonusGame: boolean) {
        //Logger.logDev("sounds - playBigWinEndSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.BW_ENDS);
            if (isBonusGame) {
                SoundManager.fadeInSound(TombOfAkhenatenSoundConfig.instance.FS_BG_MUSIC_LOOP, 2000);
            } else {
                SoundManager.fadeInSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_1, 2000);
            }
        }
    }

    //#369 scatter highlight sound start
    public static playScatterHighlightSound() {
        //Logger.logDev("sounds playScatterHighlightSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.SCATTER_HIGHLIGHT);
        }
    }

    public static playMultiplierCountUpSound() {
        //Logger.logDev("sounds playMultiplierCountUpSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.MULTIPLIER_COUNT_UP);
        }
    }
    public static stopMultiplierCountUpSound() {
        //Logger.logDev("sounds stopMultiplierCountUpSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.MULTIPLIER_COUNT_UP);
        }
    }

    public static playMultiplierCountUpEndsSound() {
        //Logger.logDev("sounds playMultiplierCountUpEndsSound");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.MULTIPLIER_COUNT_UP_ENDS);
        }
    }

    private onInitDataParsed(data: TombOfAkhenatenParsedInitData) {
        //Logger.logDev("sounds - onInitDataParsed");
        this._isBonus = TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(data.mode) > -1;
    }

    private onGameStart() {
        ////Logger.logDev("sound onGameStart");
        TOASlideShowPage.isIntroScreen = false;
    }

    private onReady() {
        //Logger.logDev("sounds - onReady");
        if (!(TombOfAkhenatenGameConfig.instance.SOUNDS_IN_DEV)) {
            if (this._isBonus) {
                SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.FS_BG_MUSIC_LOOP, Infinity, 1);
                SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_1, Infinity, 0);
            } else {
                SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_1, Infinity, 1);
            }
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_2, Infinity, 0);
            SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.MAIN_BG_MUSIC_LOOP_3, Infinity, 0);
        }
    }
}